/** provides theme to gatsby-plugin-theme-ui */

import theme from 'theme'

export default theme
